export const toggleTemperature = {
  ToggleTemperature: () => {
    function toggleTemperature({ onCompleted }) {
      onCompleted();
    }
    return [toggleTemperature, { loading: false }];
  },
};
